// depends-on: Bootstrap mobile
// depends-on: efw.local
/* global require */
(function ($) {
    const ID = require('./efw.id'),
        _ = require('lodash');

    // Eightfold Way grow-box plugin for inline-expanding content sections
    $.fn.efw$growBox = function (/* options */) {

        return this.each(function () {
            let $this = $(this),
                id = ID();

            $this.addClass('grow-control');
            let $control = $('<a class="grow-link" href="#' + id + '" data-toggle="collapse" role="button" aria-expanded="false" aria-controls="' + id + '"><span class="icon"><img src="/master_images/3/small_plus.svg" alt="" /></span><span class="text">' + 'growbox.showmore'._local() + '</span></a>');
            $this.append($control);
            $this.nextUntil('h2, .nogrow').addBack().wrapAll('<div class="growBox growGroup"></div>');
            $this.nextUntil('h2, .nogrow').wrapAll('<div class="growContent collapse" id="' + id + '"></div>');
            let $showLess = $('<div class="grow-control growUp"><a class="grow-link" href="javascript:void(0);" role="button" aria-expanded="true" aria-controls="' + id + '"><span class="icon"><img src="/master_images/3/small_minus.svg" alt="" /></span><span class="text">' + 'growbox.showless'._local() + '</span></a></div>'),
                $content = $this.parent('.growGroup').find('.growContent');
            $content.append($showLess);
            $showLess.on('click', function (e) {
                e.preventDefault();
                $control.trigger('click');
            });

            $content.on('show.bs.collapse', function () {
                    $(this).closest('.growGroup').addClass('shown');
                })
                .on('hide.bs.collapse', function () {
                    $(this).closest('.growGroup').removeClass('shown');
                });
            //$this.trackEvents({
            //    category: 'Clicks', action: 'ShowMore', label: function (o) {
            //        var $h2 = o.parent('div.growBox').prevUntil('h2').first().prev('h2');
            //        return ($h2.length > 0 ? $h2.text() : '" + strShowMore + @"');
            //    }
            //});
        });
    };

    $.fn.efw$growBoxReveal = function (hash) {
        try {
            // this whole thing can go south if the hash thing is an invalid selector.
            let sel = (hash.length > 1 ? 'a[name=' + hash.substring(1) + '], #' + hash.substring(1) : ''),
                $target = sel ? $(sel) : null;

            //console.log('selector: "' + sel + '"');

            if ($target && $target.length > 0) {
                //console.log('showing parents...');
                $target.parents('.collapse').collapse('show');
                //console.log('a: ' + $target.parents('.collapse').length);
                if ($target.is('.collapse')) {
                    //console.log('a1');
                    $target.collapse('show');
                }
                console.log('b: ' + $target.find('.collapse').length);
                $target.find('.collapse').collapse('show');
                setTimeout(function () {
                    //console.log('...scroll into view');
                    $target[0].scrollIntoView();
                }, 200);
            }
        } catch {
            // never mind.
        }
    };

    // activate globally.
    $(document).ready(function () {
        _.defer(function () {
            $('div.grow').efw$growBox();

            // if user is coming in with a hash, make sure the page is fully open to that hash.
            let hash = window.location.hash;
            if (hash.length > 1) {
                $.fn.efw$growBoxReveal(hash);
            }

            // expand everything if we're in print-this-page mode
            if ($('body').is('.pc_Article_Print')) {
                $('.collapse').collapse('show');
            }
        });
    });
})(jQuery);
